// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__qXLWd","label":"Completed_label__18Yfh"};